module.exports = __webpack_public_path__ + "static/media/cannabis.37cd653d.svg";